import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"11"}}),(_vm.showLoader)?_c(VCol,{attrs:{"cols":"1"}},[_c('LoaderProgress')],1):_vm._e()],1),_vm._l((_vm.widgets_obj_map),function(ref){
var name = ref[0];
var value = ref[1];
return _c('div',{key:name,staticStyle:{}},[_c(VRow,[_c(VCol,[_c(VBtn,{staticClass:"white--text block",attrs:{"dark":"","color":"primary"}},[_vm._v(" "+_vm._s(name)+" ")])],1)],1),_c(VRow,{staticStyle:{"margin-bottom":"20px"}},_vm._l((value),function(mac){return _c('div',{key:mac.machine_id},[_c(VCol,[_c('dpm_card',{attrs:{"properties":mac}})],1)],1)}),0)],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }